
<div class="print-error-toast" :class="toastConfig.className">
    <div class="print-error-toast__content">
        <b-avatar
            size="16px"
            class="print-error-toast__icon mr-75 flex-shrink-0"
        >
            <img
                width="16"
                height="16"
                :src="toastConfig.icon"
                :alt="variant"
            />
        </b-avatar>
        <div class="print-error-toast__text-wrapper">
            <p v-if="title" class="print-error-toast__title">{{ title }}</p>
            <div class="print-error-toast__text">
                <p
                    v-for="(line, index) in textLines"
                    :key="index"
                    :class="{ 'mt-1': index > 0 }"
                >
                    {{ line }}
                </p>
            </div>
        </div>
        <span
            class="cursor-pointer toastification__close-icon ml-auto"
            data-testid="dp-print-toast-close"
            @click="$emit('close-toast')"
        >
            <feather-icon size="18" icon="XIcon" class="mb-2" />
        </span>
    </div>
</div>
